module.exports = __webpack_public_path__ + "img/background_logo.3e066f59.png";